var _classCallCheck = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/createClass.js");

var _inherits = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var _ = require("lodash");

var BaseResource = require("./BaseResource");

var Sites = /*#__PURE__*/function (_BaseResource) {
  "use strict";

  _inherits(Sites, _BaseResource);

  var _super = _createSuper(Sites);

  function Sites(client) {
    var _this;

    _classCallCheck(this, Sites);

    _this = _super.call(this, client);
    _this.path = "api/".concat(client.options && client.options.tenantId ? "".concat(client.options.tenantId, "/") : "", "webhooks");
    return _this;
  }

  _createClass(Sites, [{
    key: "publishSlackMessage",
    value: function publishSlackMessage() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._post("".concat(this.path, "/publish-slack-message/").concat(this.integratorId, "/").concat(this.accessToken), data, options);
    }
  }, {
    key: "publishSNSMessage",
    value: function publishSNSMessage() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._post("".concat(this.path, "/publish-sns-message/").concat(this.integratorId, "/").concat(this.accessToken), data, options);
    }
  }, {
    key: "publishCodepipeline",
    value: function publishCodepipeline() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._post("".concat(this.path, "/publish-codepipeline/").concat(this.integratorId, "/").concat(this.accessToken), data, options);
    }
  }, {
    key: "getCodepipelineState",
    value: function getCodepipelineState() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._post("".concat(this.path, "/get-codepipeline-state/").concat(this.integratorId, "/").concat(this.accessToken), data, options);
    }
  }, {
    key: "updateSmartFeedData",
    value: function updateSmartFeedData() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._post("".concat(this.path, "/update-smartfeed-data/").concat(this.integratorId, "/").concat(this.accessToken), data, options);
    }
  }, {
    key: "updateSmartFeedMapData",
    value: function updateSmartFeedMapData() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._post("".concat(this.path, "/update-smartfeed-map-data/").concat(this.integratorId, "/").concat(this.accessToken), data, options);
    }
  }, {
    key: "updateSmartFeedXML",
    value: function updateSmartFeedXML() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._post("".concat(this.path, "/update-smartfeed-xml/").concat(this.integratorId, "/").concat(this.accessToken), data, options);
    }
  }, {
    key: "updateWebsiteSitemap",
    value: function updateWebsiteSitemap() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._post("".concat(this.path, "/update-website-sitemap-xml/").concat(this.integratorId, "/").concat(this.accessToken), data, options);
    }
  }, {
    key: "triggerGoogleJobsPush",
    value: function triggerGoogleJobsPush() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._post("".concat(this.path, "/trigger-google-jobs-push/").concat(this.integratorId, "/").concat(this.accessToken), data, options);
    }
  }, {
    key: "codepipelinelistener",
    value: function codepipelinelistener(codepipelineName) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this._post("".concat(this.path, "/codepipeline-webhook-listener/").concat(codepipelineName), data, options);
    }
  }, {
    key: "sentryListener",
    value: function sentryListener() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._post("".concat(this.path, "/sentry-webhook-listener"), data, options);
    }
  }]);

  return Sites;
}(BaseResource);

module.exports = Sites;